"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.tokens = void 0;
var BNB = {
    name: "WBNB Token",
    symbol: "WBNB",
    address: "0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c",
    chainId: 56,
    decimals: 18,
    logoURI: "https://exchange.pancakeswap.finance/images/coins/0xbb4cdb9cbd36b01bd1cbaebf2de08d9173bc095c.png",
};
exports.tokens = {
    DG: {
        name: "Decentralized Game",
        symbol: "DG",
        address: "0x9Fdc3ae5c814b79dcA2556564047C5e7e5449C19",
        chainId: 56,
        decimals: 18,
        logoURI: "https://tokens.pancakeswap.finance/images/0x9Fdc3ae5c814b79dcA2556564047C5e7e5449C19.png",
    },
    WOO: {
        name: "Woo",
        symbol: "WOO",
        address: "0x4691937a7508860F876c9c0a2a617E7d9E945D4B",
        chainId: 56,
        decimals: 18,
        logoURI: "https://tokens.pancakeswap.finance/images/0x4691937a7508860F876c9c0a2a617E7d9E945D4B.png",
    },
    HTB: {
        name: "Hotbit",
        symbol: "HTB",
        address: "0x4e840AADD28DA189B9906674B4Afcb77C128d9ea",
        chainId: 56,
        decimals: 18,
        logoURI: "https://tokens.pancakeswap.finance/images/0x4e840AADD28DA189B9906674B4Afcb77C128d9ea.png",
    },
    MARSH: {
        name: "MARSH",
        symbol: "MARSH",
        address: "0x2FA5dAF6Fe0708fBD63b1A7D1592577284f52256",
        chainId: 56,
        decimals: 18,
        logoURI: "https://tokens.pancakeswap.finance/images/0x2FA5dAF6Fe0708fBD63b1A7D1592577284f52256.png",
    },
    BORING: {
        name: "BoringDAO",
        symbol: "BORING",
        address: "0xffEecbf8D7267757c2dc3d13D730E97E15BfdF7F",
        chainId: 56,
        decimals: 18,
        logoURI: "https://tokens.pancakeswap.finance/images/0xffEecbf8D7267757c2dc3d13D730E97E15BfdF7F.png",
    },
    HAI: {
        name: "Hai",
        symbol: "HAI",
        address: "0xaA9E582e5751d703F85912903bacADdFed26484C",
        chainId: 56,
        decimals: 8,
        logoURI: "https://tokens.pancakeswap.finance/images/0xaA9E582e5751d703F85912903bacADdFed26484C.png",
    },
    O3: {
        name: "O3",
        symbol: "O3",
        address: "0xEe9801669C6138E84bD50dEB500827b776777d28",
        chainId: 56,
        decimals: 18,
        logoURI: "https://tokens.pancakeswap.finance/images/0xEe9801669C6138E84bD50dEB500827b776777d28.png",
    },
    TENFI: {
        name: "TENFI",
        symbol: "TENFI",
        address: "0xd15C444F1199Ae72795eba15E8C1db44E47abF62",
        chainId: 56,
        decimals: 18,
        logoURI: "https://bscscan.com/token/images/tenfinance_32.png",
    },
    MBOX: {
        name: "Mobox",
        symbol: "MBOX",
        address: "0x3203c9E46cA618C8C1cE5dC67e7e9D75f5da2377",
        chainId: 56,
        decimals: 18,
        logoURI: "https://bscscan.com/token/images/mobox_32.png",
    },
    ATA: {
        name: "Automata",
        symbol: "ATA",
        address: "0xA2120b9e674d3fC3875f415A7DF52e382F141225",
        chainId: 56,
        decimals: 18,
        logoURI: "https://bscscan.com/token/images/automata_32.png",
    },
    SHIB: {
        name: "SHIBA INU",
        symbol: "SHIB",
        address: "0x2859e4544C4bB03966803b044A93563Bd2D0DD4D",
        chainId: 56,
        decimals: 18,
        logoURI: "https://bscscan.com/token/images/shibatoken_32.png",
    },
    CELR: {
        name: "CelerToken",
        symbol: "CELR",
        address: "0x1f9f6a696C6Fd109cD3956F45dC709d2b3902163",
        chainId: 56,
        decimals: 18,
        logoURI: "https://bscscan.com/token/images/celernetwork_32.png",
    },
    GARUDA: {
        name: "GarudaSwap",
        symbol: "GARUDA",
        address: "0x854086dC841e1bfae50Cb615bF41f55BF432a90b",
        chainId: 56,
        decimals: 18,
        logoURI: "https://bscscan.com/token/images/garudaswap_32.png",
    },
    WINGS: {
        name: "JetSwap",
        symbol: "WINGS",
        address: "0x0487b824c8261462F88940f97053E65bDb498446",
        chainId: 56,
        decimals: 18,
        logoURI: "https://bscscan.com/token/images/jetswap_32.png",
    },
    SDUMP: {
        name: "Space Dumpling",
        symbol: "SDUMP",
        address: "0x13F6751ba11337BC67aBBdAd638a56194ee133B8",
        chainId: 56,
        decimals: 18,
        logoURI: "https://bscscan.com/token/images/dumplingdefi2_32.png",
    },
    SAT: {
        name: "Satisfi",
        symbol: "xSAT",
        address: "0x8fda94079913CB921D065Ed9c004Afb43e1f900e",
        chainId: 56,
        decimals: 18,
        logoURI: "https://bscscan.com/images/main/empty-token.png",
    },
    TOFY: {
        name: "Tofy",
        symbol: "TOFY",
        address: "0xE1F2d89a6c79b4242F300f880e490A70083E9A1c",
        chainId: 56,
        decimals: 18,
        logoURI: "https://bscscan.com/images/main/empty-token.png",
    },
    MASH: {
        name: "Marshmallow",
        symbol: "MASH",
        address: "0x787732f27D18495494cea3792ed7946BbCFF8db2",
        chainId: 56,
        decimals: 18,
        logoURI: "https://bscscan.com/token/images/marshmellowtoken_32.png?v=4",
    },
    BLZD: {
        name: "Blizzard",
        symbol: "BLZD",
        address: "0x57067A6BD75c0E95a6A5f158455926e43E79BeB0",
        chainId: 56,
        decimals: 18,
        logoURI: "https://bscscan.com/images/main/empty-token.png",
    },
    BITI: {
        name: "biti city",
        symbol: "BITI",
        address: "0xA25Dab5B75aC0E0738E58E49734295baD43d73F1",
        chainId: 56,
        decimals: 18,
        logoURI: "https://bscscan.com/images/main/empty-token.png",
    },
    PALM: {
        name: "Palm",
        symbol: "PALM",
        address: "0x9768E5b2d8e761905BC81Dfc554f9437A46CdCC6",
        chainId: 56,
        decimals: 18,
        logoURI: "https://bscscan.com/token/images/yieldbay_32.png",
    },
    BGO: {
        name: "Bingo Cash",
        symbol: "BGO",
        address: "0x579A6277a6c2c63a5b25006F63Bce5DC8D9c25e7",
        chainId: 56,
        decimals: 18,
        logoURI: "https://bscscan.com/token/images/bingocash_32.png",
    },
    sBGO: {
        name: "Bingo Share",
        symbol: "sBGO",
        address: "0x53F39324Fbb209693332B87aA94D5519A1a49aB0",
        chainId: 56,
        decimals: 18,
        logoURI: "https://bscscan.com/token/images/bingocash-share_32.png",
    },
    TNDR: {
        name: "Thunder",
        symbol: "TNDR",
        address: "0x7Cc46141AB1057b1928de5Ad5Ee78Bb37eFC4868",
        chainId: 56,
        decimals: 18,
        logoURI: "https://bscscan.com/token/images/thunderswap_32.png",
    },
    SWIRL: {
        name: "Swirl Cash",
        symbol: "SWIRL",
        address: "0x52d86850bc8207b520340B7E39cDaF22561b9E56",
        chainId: 56,
        decimals: 18,
        logoURI: "https://bscscan.com/token/images/swirlcash_32.png",
    },
    HPS: {
        name: "Happiness",
        symbol: "HPS",
        address: "0xeDa21B525Ac789EaB1a08ef2404dd8505FfB973D",
        chainId: 56,
        decimals: 18,
        logoURI: "https://bscscan.com/token/images/happiness_32.png",
    },
    PMP: {
        name: "Pumpy",
        symbol: "PMP",
        address: "0x8d4FBB3AC63bf33851dCE80D63613Df1A515BC00",
        chainId: 56,
        decimals: 18,
        logoURI: "https://bscscan.com/images/main/empty-token.png",
    },
    COM: {
        name: "Complus",
        symbol: "COM",
        address: "0x7fa892544D49598460B821De4D99E8c28b1Decaa",
        chainId: 56,
        decimals: 18,
        logoURI: "https://bscscan.com/images/main/empty-token.png",
    },
    NUTS: {
        name: "Squirrel Finance",
        symbol: "NUTS",
        address: "0x8893D5fA71389673C5c4b9b3cb4EE1ba71207556",
        chainId: 56,
        decimals: 18,
        logoURI: "https://bscscan.com/token/images/squirrel_32.png",
    },
    APE: {
        name: "APEcoin",
        symbol: "APE",
        address: "0xa9eA4b786ee5b7A733c035564Bfd9341A4c9FC1e",
        chainId: 56,
        decimals: 18,
        logoURI: "https://bscscan.com/token/images/apecoin_32.png?=v1",
    },
    MFRM: {
        name: "MemeFarm",
        symbol: "MFRM",
        address: "0x206340f3361404910F45cA0893980EF3f9b418ea",
        chainId: 56,
        decimals: 18,
        logoURI: "https://bscscan.com/token/images/memefarm_32.png",
    },
    SLME: {
        name: "Slime",
        symbol: "SLME",
        address: "0x4fCfA6cC8914ab455B5b33Df916d90BFe70b6AB1",
        chainId: 56,
        decimals: 18,
        logoURI: "https://bscscan.com/images/main/empty-token.png",
    },
    JulD: {
        name: "JulSwap",
        symbol: "JulD",
        address: "0x5A41F637C3f7553dBa6dDC2D3cA92641096577ea",
        chainId: 56,
        decimals: 18,
        logoURI: "https://tokens.julswap.com/images/0x5A41F637C3f7553dBa6dDC2D3cA92641096577ea.png",
    },
    SOUP: {
        name: "Soup",
        symbol: "SOUP",
        address: "0x94F559aE621F1c810F31a6a620Ad7376776fe09E",
        chainId: 56,
        decimals: 18,
        logoURI: "https://bscscan.com/token/images/soupfinance_32.png",
    },
    SOUPS: {
        name: "Soup Share",
        symbol: "SOUPS",
        address: "0x69F27E70E820197A6e495219D9aC34C8C6dA7EeE",
        chainId: 56,
        decimals: 18,
        logoURI: "https://bscscan.com/token/images/soupshare_32.png",
    },
    "1INCH": {
        name: "1INCH",
        symbol: "1INCH",
        address: "0x111111111117dC0aa78b770fA6A738034120C302",
        chainId: 56,
        decimals: 18,
        logoURI: "https://tokens.1inch.exchange/0x111111111117dc0aa78b770fa6a738034120c302.png",
    },
    STEAM: {
        name: "Steam",
        symbol: "STEAM",
        address: "0x072e3D0D4f14dd82a16B0a33678c6104e9009ED9",
        chainId: 56,
        decimals: 18,
        logoURI: "https://bscscan.com/token/images/steam_32.png",
    },
    SALT: {
        name: "Salt",
        symbol: "SALT",
        address: "0x2849b1aE7E04A3D9Bc288673A92477CF63F28aF4",
        chainId: 56,
        decimals: 18,
        logoURI: "https://bscscan.com/token/images/saltswap_32.png",
    },
    CROW: {
        name: "Crow",
        symbol: "CROW",
        address: "0xcc2E12a9b5b75360c6FBf23B584c275D52cDdb0E",
        chainId: 56,
        decimals: 18,
        logoURI: "https://bscscan.com/token/images/crowfinance_32.png?=v1",
    },
    RAMEN: {
        name: "Ramen",
        symbol: "RAMEN",
        address: "0x4F47A0d15c1E53F3d94c069C7D16977c29F9CB6B",
        chainId: 56,
        decimals: 18,
        logoURI: "https://bscscan.com/token/images/ramenswap_32.png",
    },
    BREW: {
        name: "CafeSwap",
        symbol: "BREW",
        address: "0x790Be81C3cA0e53974bE2688cDb954732C9862e1",
        chainId: 56,
        decimals: 18,
        logoURI: "https://bscscan.com/token/images/cafeswap_32.png",
    },
    MSC: {
        name: "Monster Slayer Cash",
        symbol: "MSC",
        address: "0x8C784C49097Dcc637b93232e15810D53871992BF",
        chainId: 56,
        decimals: 18,
        logoURI: "https://bscscan.com/token/images/monsterslayer_32.png?=v1",
    },
    BTS: {
        name: "Bat True Share",
        symbol: "BTS",
        address: "0xc2e1acef50aE55661855E8dcB72adB182A3cC259",
        chainId: 56,
        decimals: 18,
        logoURI: "https://bscscan.com/token/images/boltshare_32.png",
    },
    BTD: {
        name: "Bat True Dollar",
        symbol: "BTD",
        address: "0xD1102332a213E21faF78B69C03572031F3552c33",
        chainId: 56,
        decimals: 18,
        logoURI: "https://bscscan.com/token/images/batdollar-btd_32.png",
    },
    KEBAB: {
        name: "Kebab",
        symbol: "KEBAB",
        address: "0x7979F6C54ebA05E18Ded44C4F986F49a5De551c2",
        chainId: 56,
        decimals: 18,
        logoURI: "https://bscscan.com/token/images/kebabfinance_32.png",
    },
    SPG: {
        name: "Sponge",
        symbol: "SPG",
        address: "0x3aabCf53A1930A42E18D938C019E83Ebee50a849",
        chainId: 56,
        decimals: 9,
        logoURI: "https://bscscan.com/token/images/sponge_32.png",
    },
    SOAK: {
        name: "Soak",
        symbol: "SOAK",
        address: "0x849233FF1aea15D80EF658B2871664C9Ca994063",
        chainId: 56,
        decimals: 18,
        logoURI: "https://bscscan.com/token/images/sponge-soak_32.png",
    },
    NYAS: {
        name: "NYA Share",
        symbol: "NYAS",
        address: "0xD7410C38a86DCf3D5EC0F75e9763111E07D9C95b",
        chainId: 56,
        decimals: 18,
        logoURI: "https://bscscan.com/token/images/nyacash-share_32.png",
    },
    MSS: {
        name: "Monster Slayer Share",
        symbol: "MSS",
        address: "0xAcABD3f9b8F76fFd2724604185Fa5AFA5dF25aC6",
        chainId: 56,
        decimals: 18,
        logoURI: "https://bscscan.com/token/images/monsterslayer-mss_32.png",
    },
    VAPOR: {
        name: "VAPOR",
        symbol: "VAPOR",
        address: "0x86ac8a05Cc4eEd2BEa32D271dE50e2A3d129b6B6",
        chainId: 56,
        decimals: 9,
        logoURI: "https://tokens.julswap.com/images/0x5A41F637C3f7553dBa6dDC2D3cA92641096577ea.png",
    },
    SBDO: {
        name: "bDollar Share",
        symbol: "SBDO",
        address: "0x0d9319565be7f53CeFE84Ad201Be3f40feAE2740",
        chainId: 56,
        decimals: 18,
        logoURI: "https://bscscan.com/token/images/bdollar-share_32.png",
    },
    BHC: {
        name: "Billion Happiness",
        symbol: "BHC",
        address: "0x6fd7c98458a943f469E1Cf4eA85B173f5Cd342F4",
        chainId: 56,
        decimals: 18,
        logoURI: "https://bscscan.com/token/images/billionhappiness_32.png?v=2",
    },
    GOLD: {
        name: "NAR Ticket",
        symbol: "GOLD",
        address: "0x8f4087Cb09E0F378f4278a314C94A636665dE24b",
        chainId: 56,
        decimals: 18,
        logoURI: "https://bscscan.com/token/images/narwhalswap-gold_32.png",
    },
    CRED: {
        name: "Street Credit",
        symbol: "CRED",
        address: "0x571D0B55fe30eb1F6E68e8799F181c46De6B0059",
        chainId: 56,
        decimals: 18,
        logoURI: "https://bscscan.com/token/images/thugs-streetcredit_32.png",
    },
    GUNS: {
        name: "Lord of War",
        symbol: "GUNS",
        address: "0x179983892eC36287f1F342443B671Ba549762241",
        chainId: 56,
        decimals: 18,
        logoURI: "https://bscscan.com/token/images/thugs-guns2_32.png",
    },
    BLIQ: {
        name: "Bliquid",
        symbol: "BLIQ",
        address: "0xC97faC34CeB0Bb1B2bdAf3b59ADA378b99111a22",
        chainId: 56,
        decimals: 18,
        logoURI: "https://bscscan.com/token/images/bliquid_32.png",
    },
    KTN: {
        name: "Kattana",
        symbol: "KTN",
        address: "0xDAe6c2A48BFAA66b43815c5548b10800919c993E",
        chainId: 56,
        decimals: 18,
        logoURI: "https://exchange.pancakeswap.finance/images/coins/0xDAe6c2A48BFAA66b43815c5548b10800919c993E.png",
    },
    TUSD: {
        name: "TrueUSD",
        symbol: "TUSD",
        address: "0x14016E85a25aeb13065688cAFB43044C2ef86784",
        chainId: 56,
        decimals: 18,
        logoURI: "https://exchange.pancakeswap.finance/images/coins/0x14016e85a25aeb13065688cafb43044c2ef86784.png",
    },
    KALM: {
        name: "KALM",
        symbol: "KALM",
        address: "0x4BA0057f784858a48fe351445C672FF2a3d43515",
        chainId: 56,
        decimals: 18,
        logoURI: "https://exchange.pancakeswap.finance/images/coins/0x4BA0057f784858a48fe351445C672FF2a3d43515.png",
    },
    EZ: {
        name: "EZ",
        symbol: "EZ",
        address: "0x5512014efa6Cd57764Fa743756F7a6Ce3358cC83",
        chainId: 56,
        decimals: 18,
        logoURI: "https://exchange.pancakeswap.finance/images/coins/0x5512014efa6Cd57764Fa743756F7a6Ce3358cC83.png",
    },
    VRT: {
        name: "VRT",
        symbol: "VRT",
        address: "0x5F84ce30DC3cF7909101C69086c50De191895883",
        chainId: 56,
        decimals: 18,
        logoURI: "https://exchange.pancakeswap.finance/images/coins/0x5f84ce30dc3cf7909101c69086c50de191895883.png",
    },
    pOPEN: {
        name: "pOPEN",
        symbol: "pOPEN",
        address: "0xaBaE871B7E3b67aEeC6B46AE9FE1A91660AadAC5",
        chainId: 56,
        decimals: 18,
        logoURI: "https://exchange.pancakeswap.finance/images/coins/0xaBaE871B7E3b67aEeC6B46AE9FE1A91660AadAC5.png",
    },
    WELL: {
        name: "BitWell",
        symbol: "WELL",
        address: "0xf07a32Eb035b786898c00bB1C64d8c6F8E7a46D5",
        chainId: 56,
        decimals: 18,
        logoURI: "https://bscscan.com/token/images/bitwellex_32.png",
    },
    SNX: {
        name: "Synthetix",
        symbol: "SNX",
        address: "0x9Ac983826058b8a9C7Aa1C9171441191232E8404",
        chainId: 56,
        decimals: 18,
        logoURI: "https://bscscan.com/token/images/snx_32.png",
    },
    BLZ: {
        name: "Bluezelle",
        symbol: "BLZ",
        address: "0x935a544Bf5816E3A7C13DB2EFe3009Ffda0aCdA2",
        chainId: 56,
        decimals: 18,
        logoURI: "https://dex.apeswap.finance/images/coins/blz.svg",
    },
    DERI: {
        name: "Deri",
        symbol: "DERI",
        address: "0xe60eaf5A997DFAe83739e035b005A33AfdCc6df5",
        chainId: 56,
        decimals: 18,
        logoURI: "https://exchange.pancakeswap.finance/images/coins/0xe60eaf5A997DFAe83739e035b005A33AfdCc6df5.png",
    },
    CHR: {
        name: "Chromia",
        symbol: "CHR",
        address: "0xf9CeC8d50f6c8ad3Fb6dcCEC577e05aA32B224FE",
        chainId: 56,
        decimals: 6,
        logoURI: "https://exchange.pancakeswap.finance/images/coins/0xf9CeC8d50f6c8ad3Fb6dcCEC577e05aA32B224FE.png",
    },
    XEND: {
        name: "XEND",
        symbol: "XEND",
        address: "0x4a080377f83D669D7bB83B3184a8A5E61B500608",
        chainId: 56,
        decimals: 18,
        logoURI: "https://bscscan.com/token/images/xendfinance_32.png",
    },
    CYC: {
        name: "Cyclone Protocol",
        symbol: "CYC",
        address: "0x810EE35443639348aDbbC467b33310d2AB43c168",
        chainId: 56,
        decimals: 18,
        logoURI: "https://bscscan.com/token/images/cyclone_32.png",
    },
    ZEC: {
        name: "Z-Cash",
        symbol: "ZEC",
        address: "0x1Ba42e5193dfA8B03D15dd1B86a3113bbBEF8Eeb",
        chainId: 56,
        decimals: 18,
        logoURI: "https://dex.apeswap.finance/images/coins/ZEC.svg",
    },
    ETC: {
        name: "Ethereum Classic",
        symbol: "ETC",
        address: "0x3d6545b08693daE087E957cb1180ee38B9e3c25E",
        chainId: 56,
        decimals: 18,
        logoURI: "https://dex.apeswap.finance/images/coins/ETC.svg",
    },
    COTI: {
        name: "Coti",
        symbol: "COTI",
        address: "0xAdBAF88B39D37Dc68775eD1541F1bf83A5A45feB",
        chainId: 56,
        decimals: 18,
        logoURI: "https://dex.apeswap.finance/images/coins/coti.svg",
    },
    NEAR: {
        name: "Near",
        symbol: "NEAR",
        address: "0x1Fa4a73a3F0133f0025378af00236f3aBDEE5D63",
        chainId: 56,
        decimals: 18,
        logoURI: "https://dex.apeswap.finance/images/coins/near.svg",
    },
    GRAND: {
        name: "Grand",
        symbol: "GRAND",
        address: "0xeE814F5B2bF700D2e843Dc56835D28d095161dd9",
        chainId: 56,
        decimals: 18,
        logoURI: "https://bscscan.com/token/images/grandtoken_32.png",
    },
    SWAMP: {
        name: "Swampy Token",
        symbol: "SWAMP",
        address: "0xc5A49b4CBe004b6FD55B30Ba1dE6AC360FF9765d",
        chainId: 56,
        decimals: 18,
        logoURI: "https://bscscan.com/token/images/swampfinance_32.png",
    },
    HOTCROSS: {
        name: "Hot Cross Token",
        address: "0x4FA7163E153419E0E1064e418dd7A99314Ed27b6",
        symbol: "HOTCROSS",
        decimals: 18,
        chainId: 56,
        logoURI: "https://exchange.pancakeswap.finance/images/coins/0x4fa7163e153419e0e1064e418dd7a99314ed27b6.png",
    },
    RFOX: {
        name: "RFOX Token",
        address: "0x0a3A21356793B49154Fd3BbE91CBc2A16c0457f5",
        symbol: "RFOX",
        decimals: 18,
        chainId: 56,
        logoURI: "https://exchange.pancakeswap.finance/images/coins/0x0a3a21356793b49154fd3bbe91cbc2a16c0457f5.png",
    },
    HYFI: {
        name: "HYFI Token",
        symbol: "HYFI",
        address: "0x9a319b959e33369C5eaA494a770117eE3e585318",
        chainId: 56,
        decimals: 18,
        logoURI: "https://exchange.pancakeswap.finance/images/coins/0x9a319b959e33369C5eaA494a770117eE3e585318.png",
    },
    FINE: {
        name: "Refinable Token",
        symbol: "FINE",
        address: "0x4e6415a5727ea08aAE4580057187923aeC331227",
        chainId: 56,
        decimals: 18,
        logoURI: "https://bscscan.com/token/images/refinable_32.png",
    },
    tDOGE: {
        name: "╧äDogecoin Token",
        symbol: "tDOGE",
        address: "0xe550a593d09FBC8DCD557b5C88Cea6946A8b404A",
        chainId: 56,
        decimals: 8,
        logoURI: "https://exchange.pancakeswap.finance/images/coins/0xe550a593d09fbc8dcd557b5c88cea6946a8b404a.png",
    },
    OIN: {
        name: "oinfinance Token",
        symbol: "OIN",
        address: "0x658E64FFcF40D240A43D52CA9342140316Ae44fA",
        chainId: 56,
        decimals: 8,
        logoURI: "https://exchange.pancakeswap.finance/images/coins/0x658E64FFcF40D240A43D52CA9342140316Ae44fA.png",
    },
    ONE: {
        name: "BigONE Token",
        symbol: "ONE",
        address: "0x04BAf95Fd4C52fd09a56D840bAEe0AB8D7357bf0",
        chainId: 56,
        decimals: 18,
        logoURI: "https://exchange.pancakeswap.finance/images/coins/0x04BAf95Fd4C52fd09a56D840bAEe0AB8D7357bf0.png",
    },
    PMON: {
        name: "Polkamon Token",
        symbol: "PMON",
        address: "0x1796ae0b0fa4862485106a0de9b654eFE301D0b2",
        chainId: 56,
        decimals: 18,
        logoURI: "https://exchange.pancakeswap.finance/images/coins/0x1796ae0b0fa4862485106a0de9b654eFE301D0b2.png",
    },
    BTR: {
        name: "Bitrue Token",
        symbol: "BTR",
        address: "0x5a16E8cE8cA316407c6E6307095dc9540a8D62B3",
        chainId: 56,
        decimals: 18,
        logoURI: "https://exchange.pancakeswap.finance/images/coins/0x5a16E8cE8cA316407c6E6307095dc9540a8D62B3.png",
    },
    UBXT: {
        name: "UpBots Token",
        symbol: "UBXT",
        address: "0xBbEB90cFb6FAFa1F69AA130B7341089AbeEF5811",
        chainId: 56,
        decimals: 18,
        logoURI: "https://exchange.pancakeswap.finance/images/coins/0xbbeb90cfb6fafa1f69aa130b7341089abeef5811.png",
    },
    WMASS: {
        name: "Wrapped MASS Token",
        symbol: "WMASS",
        address: "0x7e396BfC8a2f84748701167c2d622F041A1D7a17",
        chainId: 56,
        decimals: 8,
        logoURI: "https://exchange.pancakeswap.finance/images/coins/0x7e396bfc8a2f84748701167c2d622f041a1d7a17.png",
    },
    FTS: {
        name: "Fortress Token",
        symbol: "FTS",
        address: "0x4437743ac02957068995c48E08465E0EE1769fBE",
        chainId: 56,
        decimals: 18,
        logoURI: "https://bscscan.com/token/images/fortress_32.png?v=4",
    },
    DND: {
        name: "DIAMOND Token",
        symbol: "DND",
        address: "0x34EA3F7162E6f6Ed16bD171267eC180fD5c848da",
        chainId: 56,
        decimals: 18,
        logoURI: "https://bscscan.com/token/images/diamond_32.png",
    },
    ZEFI: {
        name: "ZCore Finance Token",
        symbol: "ZEFI",
        address: "0x0288D3E353fE2299F11eA2c2e1696b4A648eCC07",
        chainId: 56,
        decimals: 18,
        logoURI: "https://bscscan.com/token/images/zcore-zefi_32.png",
    },
    ICA: {
        name: "ICA Token",
        symbol: "ICA",
        address: "0x95111f630aC215Eb74599ED42C67E2c2790d69e2",
        chainId: 56,
        decimals: 18,
        logoURI: "https://bscscan.com/token/images/icarus_32.png",
    },
    STEEL: {
        name: "IRON Share V2 Token",
        symbol: "STEEL",
        address: "0x9001eE054F1692feF3A48330cB543b6FEc6287eb",
        chainId: 56,
        decimals: 18,
        logoURI: "https://bscscan.com/token/images/ironfinance-share_32.png",
    },
    TYPH: {
        name: "Typhoon Token",
        symbol: "TYPH",
        address: "0x4090e535F2e251F5F88518998B18b54d26B3b07c",
        chainId: 56,
        decimals: 18,
        logoURI: "https://bscscan.com/token/images/typhoonnetwork_32.png",
    },
    IRON: {
        name: "IRON Stablecoin Token",
        symbol: "IRON",
        address: "0x7b65B489fE53fCE1F6548Db886C08aD73111DDd8",
        chainId: 56,
        decimals: 18,
        logoURI: "https://bscscan.com/token/images/ironfinance_32.png?=v1",
    },
    KEYFI: {
        name: "KeyFi Token",
        symbol: "KEYFI",
        address: "0x4b6000F9163de2E3f0a01eC37E06e1469DBbcE9d",
        chainId: 56,
        decimals: 18,
        logoURI: "https://dex.apeswap.finance/images/coins/XBTC.svg",
    },
    BXBTC: {
        name: "bxBTC Token",
        symbol: "BXBTC",
        address: "0xab111D5948470Ba73d98D66BBdf2798FBE093546",
        chainId: 56,
        decimals: 9,
        logoURI: "https://dex.apeswap.finance/images/coins/XBTC.svg",
    },
    NAUT: {
        name: "Astronaut Token",
        symbol: "NAUT",
        address: "0x05B339B0A346bF01f851ddE47a5d485c34FE220c",
        chainId: 56,
        decimals: 8,
        logoURI: "https://dex.apeswap.finance/images/coins/NAUT.png",
    },
    IOTA: {
        name: "MIOTAC Token",
        symbol: "IOTA",
        address: "0xd944f1D1e9d5f9Bb90b62f9D45e447D989580782",
        chainId: 56,
        decimals: 6,
        logoURI: "https://dex.apeswap.finance/images/coins/IOTA.png",
    },
    AVAX: {
        name: "Avalanche Token",
        symbol: "AVAX",
        address: "0x1CE0c2827e2eF14D5C4f29a091d735A204794041",
        chainId: 56,
        decimals: 18,
        logoURI: "https://dex.apeswap.finance/images/coins/avax.png",
    },
    BANANA: {
        name: "ApeSwapFinance Banana",
        symbol: "BANANA",
        address: "0x603c7f932ED1fc6575303D8Fb018fDCBb0f39a95",
        chainId: 56,
        decimals: 18,
        logoURI: "https://dex.apeswap.finance/images/coins/BANANA.svg",
    },
    FTM: {
        name: "Fantom",
        symbol: "FTM",
        address: "0xAD29AbB318791D579433D831ed122aFeAf29dcfe",
        chainId: 56,
        decimals: 18,
        logoURI: "https://dex.apeswap.finance/images/coins/FTM.svg",
    },
    AAVE: {
        name: "Binance-Peg Aave Token",
        symbol: "AAVE",
        address: "0xfb6115445Bff7b52FeB98650C87f44907E58f802",
        chainId: 56,
        decimals: 18,
        logoURI: "https://dex.apeswap.finance/images/coins/AAVE.svg",
    },
    MATIC: {
        name: "Matic Token",
        symbol: "MATIC",
        address: "0xCC42724C6683B7E57334c4E856f4c9965ED682bD",
        chainId: 56,
        decimals: 18,
        logoURI: "https://dex.apeswap.finance/images/coins/MATIC.svg",
    },
    DOGE: {
        name: "Binance-Peg Dogecoin",
        symbol: "DOGE",
        address: "0xbA2aE424d960c26247Dd6c32edC70B295c744C43",
        chainId: 56,
        decimals: 8,
        logoURI: "https://exchange.pancakeswap.finance/images/coins/0xba2ae424d960c26247dd6c32edc70b295c744c43.png",
    },
    HAKKA: {
        name: "Hakka Finance on xDai on BSC TOKEN",
        symbol: "HAKKA",
        address: "0x1D1eb8E8293222e1a29d2C0E4cE6C0Acfd89AaaC",
        chainId: 56,
        decimals: 18,
        logoURI: "https://exchange.pancakeswap.finance/images/coins/0x1d1eb8e8293222e1a29d2c0e4ce6c0acfd89aaac.png",
    },
    XED: {
        name: "Exeedme TOKEN",
        symbol: "XED",
        address: "0x5621b5A3f4a8008c4CCDd1b942B121c8B1944F1f",
        chainId: 56,
        decimals: 18,
        logoURI: "https://exchange.pancakeswap.finance/images/coins/0x5621b5a3f4a8008c4ccdd1b942b121c8b1944f1f.png",
    },
    CGG: {
        name: "pTokens CGG TOKEN",
        symbol: "CGG",
        address: "0x1613957159E9B0ac6c80e824F7Eea748a32a0AE2",
        chainId: 56,
        decimals: 18,
        logoURI: "https://exchange.pancakeswap.finance/images/coins/0x1613957159e9b0ac6c80e824f7eea748a32a0ae2.png",
    },
    DFD: {
        name: "DefiDollar DAO TOKEN",
        symbol: "DFD",
        address: "0x9899a98b222fCb2f3dbee7dF45d943093a4ff9ff",
        chainId: 56,
        decimals: 18,
        logoURI: "https://exchange.pancakeswap.finance/images/coins/0x9899a98b222fcb2f3dbee7df45d943093a4ff9ff.png",
    },
    LMT: {
        name: "Lympo Market TOKEN",
        symbol: "LMT",
        address: "0x9617857E191354dbEA0b714d78Bc59e57C411087",
        chainId: 56,
        decimals: 18,
        logoURI: "https://exchange.pancakeswap.finance/images/coins/0x9617857e191354dbea0b714d78bc59e57c411087.png",
    },
    SUTER: {
        name: "Suterusu TOKEN",
        symbol: "SUTER",
        address: "0x4CfbBdfBd5BF0814472fF35C72717Bd095ADa055",
        chainId: 56,
        decimals: 18,
        logoURI: "https://exchange.pancakeswap.finance/images/coins/0x4cfbbdfbd5bf0814472ff35c72717bd095ada055.png",
    },
    GOAL: {
        name: "Goal TOKEN",
        symbol: "GOAL",
        address: "0xE5b57E6e1b945B91FEE368aC108d2ebCcA78Aa8F",
        chainId: 56,
        decimals: 18,
        logoURI: "",
    },
    SPACE: {
        name: "farm.space TOKEN",
        symbol: "SPACE",
        address: "0x0abd3E3502c15ec252f90F64341cbA74a24fba06",
        chainId: 56,
        decimals: 18,
        logoURI: "",
    },
    WIN: {
        name: "WINk Token",
        symbol: "WIN",
        address: "0xaeF0d72a118ce24feE3cD1d43d383897D05B4e99",
        chainId: 56,
        decimals: 18,
        logoURI: "https://exchange.pancakeswap.finance/images/coins/0xaef0d72a118ce24fee3cd1d43d383897d05b4e99.png",
    },
    TRX: {
        name: "TRON Token",
        symbol: "TRX",
        address: "0x85EAC5Ac2F758618dFa09bDbe0cf174e7d574D5B",
        chainId: 56,
        decimals: 18,
        logoURI: "https://exchange.pancakeswap.finance/images/coins/0x85eac5ac2f758618dfa09bdbe0cf174e7d574d5b.png",
    },
    BTT: {
        name: "BitTorrent Token",
        symbol: "BTT",
        address: "0x8595F9dA7b868b1822194fAEd312235E43007b49",
        chainId: 56,
        decimals: 18,
        logoURI: "https://exchange.pancakeswap.finance/images/coins/0x8595f9da7b868b1822194faed312235e43007b49.png",
    },
    mCOIN: {
        name: "Wrapped Mirror COIN Token",
        symbol: "mCOIN",
        address: "0x49022089e78a8D46Ec87A3AF86a1Db6c189aFA6f",
        chainId: 56,
        decimals: 18,
        logoURI: "https://exchange.pancakeswap.finance/images/coins/0x49022089e78a8d46ec87a3af86a1db6c189afa6f.png",
    },
    MDX: {
        name: "MDEX Token",
        symbol: "MDX",
        address: "0x9C65AB58d8d978DB963e63f2bfB7121627e3a739",
        chainId: 56,
        decimals: 18,
        logoURI: "https://mdex.com/token-icons/bsc/0x9c65ab58d8d978db963e63f2bfb7121627e3a739.png",
    },
    xBLZD: {
        name: "xBLZD Token",
        symbol: "xBLZD",
        address: "0x9a946c3Cb16c08334b69aE249690C236Ebd5583E",
        chainId: 56,
        decimals: 18,
        logoURI: "https://app.beefy.finance/static/media/BLZD.fdf1fc8d.png",
    },
    WBNB: BNB,
    WNATIVE: BNB,
    BAKE: {
        name: "Bakery Token",
        symbol: "BAKE",
        address: "0xE02dF9e3e622DeBdD69fb838bB799E3F168902c5",
        chainId: 56,
        decimals: 18,
        logoURI: "https://exchange.pancakeswap.finance/images/coins/0xe02df9e3e622debdd69fb838bb799e3f168902c5.png",
    },
    BUSD: {
        name: "BUSD Token",
        symbol: "BUSD",
        address: "0xe9e7CEA3DedcA5984780Bafc599bD69ADd087D56",
        chainId: 56,
        decimals: 18,
        logoURI: "https://exchange.pancakeswap.finance/images/coins/0xe9e7cea3dedca5984780bafc599bd69add087d56.png",
    },
    ETH: {
        name: "Ethereum Token",
        symbol: "ETH",
        address: "0x2170Ed0880ac9A755fd29B2688956BD959F933F8",
        chainId: 56,
        decimals: 18,
        logoURI: "https://exchange.pancakeswap.finance/images/coins/0x2170ed0880ac9a755fd29b2688956bd959f933f8.png",
    },
    BTCB: {
        name: "BTCB Token",
        symbol: "BTCB",
        address: "0x7130d2A12B9BCbFAe4f2634d864A1Ee1Ce3Ead9c",
        chainId: 56,
        decimals: 18,
        logoURI: "https://exchange.pancakeswap.finance/images/coins/0x7130d2a12b9bcbfae4f2634d864a1ee1ce3ead9c.png",
    },
    BAND: {
        name: "BAND Protocol Token",
        symbol: "BAND",
        address: "0xAD6cAEb32CD2c308980a548bD0Bc5AA4306c6c18",
        chainId: 56,
        decimals: 18,
        logoURI: "https://exchange.pancakeswap.finance/images/coins/0xad6caeb32cd2c308980a548bd0bc5aa4306c6c18.png",
    },
    EOS: {
        name: "EOS Token",
        symbol: "EOS",
        address: "0x56b6fB708fC5732DEC1Afc8D8556423A2EDcCbD6",
        chainId: 56,
        decimals: 18,
        logoURI: "https://exchange.pancakeswap.finance/images/coins/0x56b6fb708fc5732dec1afc8d8556423a2edccbd6.png",
    },
    USDT: {
        name: "Tether USD",
        symbol: "USDT",
        address: "0x55d398326f99059fF775485246999027B3197955",
        chainId: 56,
        decimals: 18,
        logoURI: "https://exchange.pancakeswap.finance/images/coins/0x55d398326f99059ff775485246999027b3197955.png",
    },
    XRP: {
        name: "XRP Token",
        symbol: "XRP",
        address: "0x1D2F0da169ceB9fC7B3144628dB156f3F6c60dBE",
        chainId: 56,
        decimals: 18,
        logoURI: "https://exchange.pancakeswap.finance/images/coins/0x1d2f0da169ceb9fc7b3144628db156f3f6c60dbe.png",
    },
    BCH: {
        name: "Bitcoin Cash Token",
        symbol: "BCH",
        address: "0x8fF795a6F4D97E7887C79beA79aba5cc76444aDf",
        chainId: 56,
        decimals: 18,
        logoURI: "https://exchange.pancakeswap.finance/images/coins/0x8ff795a6f4d97e7887c79bea79aba5cc76444adf.png",
    },
    LTC: {
        name: "Litecoin Token",
        symbol: "LTC",
        address: "0x4338665CBB7B2485A8855A139b75D5e34AB0DB94",
        chainId: 56,
        decimals: 18,
        logoURI: "https://exchange.pancakeswap.finance/images/coins/0x4338665cbb7b2485a8855a139b75d5e34ab0db94.png",
    },
    ADA: {
        name: "Cardano Token",
        symbol: "ADA",
        address: "0x3EE2200Efb3400fAbB9AacF31297cBdD1d435D47",
        chainId: 56,
        decimals: 18,
        logoURI: "https://exchange.pancakeswap.finance/images/coins/0x3ee2200efb3400fabb9aacf31297cbdd1d435d47.png",
    },
    ATOM: {
        name: "Cosmos Token",
        symbol: "ATOM",
        address: "0x0Eb3a705fc54725037CC9e008bDede697f62F335",
        chainId: 56,
        decimals: 18,
        logoURI: "https://exchange.pancakeswap.finance/images/coins/0x0eb3a705fc54725037cc9e008bdede697f62f335.png",
    },
    XTZ: {
        name: "Tezos Token",
        symbol: "XTZ",
        address: "0x16939ef78684453bfDFb47825F8a5F714f12623a",
        chainId: 56,
        decimals: 18,
        logoURI: "https://exchange.pancakeswap.finance/images/coins/0x16939ef78684453bfdfb47825f8a5f714f12623a.png",
    },
    ONT: {
        name: "Ontology Token",
        symbol: "ONT",
        address: "0xFd7B3A77848f1C2D67E05E54d78d174a0C850335",
        chainId: 56,
        decimals: 18,
        logoURI: "https://exchange.pancakeswap.finance/images/coins/0xfd7b3a77848f1c2d67e05e54d78d174a0c850335.png",
    },
    DAI: {
        name: "Dai Token",
        symbol: "DAI",
        address: "0x1AF3F329e8BE154074D8769D1FFa4eE058B1DBc3",
        chainId: 56,
        decimals: 18,
        logoURI: "https://exchange.pancakeswap.finance/images/coins/0x1af3f329e8be154074d8769d1ffa4ee058b1dbc3.png",
    },
    YFII: {
        name: "YFII.finance Token",
        symbol: "YFII",
        address: "0x7F70642d88cf1C4a3a7abb072B53B929b653edA5",
        chainId: 56,
        decimals: 18,
        logoURI: "https://exchange.pancakeswap.finance/images/coins/0x7f70642d88cf1c4a3a7abb072b53b929b653eda5.png",
    },
    CREAM: {
        name: "Cream",
        symbol: "CREAM",
        address: "0xd4CB328A82bDf5f03eB737f37Fa6B370aef3e888",
        chainId: 56,
        decimals: 18,
        logoURI: "https://exchange.pancakeswap.finance/images/coins/0xd4cb328a82bdf5f03eb737f37fa6b370aef3e888.png",
    },
    PROM: {
        name: "Prometeus",
        symbol: "PROM",
        address: "0xaF53d56ff99f1322515E54FdDE93FF8b3b7DAFd5",
        chainId: 56,
        decimals: 18,
        logoURI: "https://exchange.pancakeswap.finance/images/coins/0xaf53d56ff99f1322515e54fdde93ff8b3b7dafd5.png",
    },
    CAN: {
        name: "CanYaCoin",
        symbol: "CAN",
        address: "0x007EA5C0Ea75a8DF45D288a4debdD5bb633F9e56",
        chainId: 56,
        decimals: 18,
        logoURI: "https://exchange.pancakeswap.finance/images/coins/0x007ea5c0ea75a8df45d288a4debdd5bb633f9e56.png",
    },
    DOT: {
        name: "Polkadot Token",
        symbol: "DOT",
        address: "0x7083609fCE4d1d8Dc0C979AAb8c869Ea2C873402",
        chainId: 56,
        decimals: 18,
        logoURI: "https://exchange.pancakeswap.finance/images/coins/0x7083609fce4d1d8dc0c979aab8c869ea2c873402.png",
    },
    CAKE: {
        name: "PancakeSwap Token",
        symbol: "CAKE",
        address: "0x0E09FaBB73Bd3Ade0a17ECC321fD13a19e81cE82",
        chainId: 56,
        decimals: 18,
        logoURI: "https://exchange.pancakeswap.finance/images/coins/0x0e09fabb73bd3ade0a17ecc321fd13a19e81ce82.png",
    },
    STM: {
        name: "Streamity",
        symbol: "STM",
        address: "0x90DF11a8ccE420675e73922419e3f4f3Fe13CCCb",
        chainId: 56,
        decimals: 18,
        logoURI: "https://exchange.pancakeswap.finance/images/coins/0x90df11a8cce420675e73922419e3f4f3fe13cccb.png",
    },
    ANKR: {
        name: "Ankr",
        symbol: "ANKR",
        address: "0xf307910A4c7bbc79691fD374889b36d8531B08e3",
        chainId: 56,
        decimals: 18,
        logoURI: "https://exchange.pancakeswap.finance/images/coins/0xf307910a4c7bbc79691fd374889b36d8531b08e3.png",
    },
    LINK: {
        name: "ChainLink Token",
        symbol: "LINK",
        address: "0xF8A0BF9cF54Bb92F17374d9e9A321E6a111a51bD",
        chainId: 56,
        decimals: 18,
        logoURI: "https://exchange.pancakeswap.finance/images/coins/0xf8a0bf9cf54bb92f17374d9e9a321e6a111a51bd.png",
    },
    BURGER: {
        name: "Burger Swap",
        symbol: "BURGER",
        address: "0xAe9269f27437f0fcBC232d39Ec814844a51d6b8f",
        chainId: 56,
        decimals: 18,
        logoURI: "https://exchange.pancakeswap.finance/images/coins/0xae9269f27437f0fcbc232d39ec814844a51d6b8f.png",
    },
    DICE: {
        name: "Dice.finance Token",
        symbol: "DICE",
        address: "0x748AD98b14C814B28812eB42ad219C8672909879",
        chainId: 56,
        decimals: 18,
        logoURI: "https://exchange.pancakeswap.finance/images/coins/0x748ad98b14c814b28812eb42ad219c8672909879.png",
    },
    "JNTR/b": {
        name: "JNTR/b",
        symbol: "JNTR/b",
        address: "0x3c037C4c2296f280bB318D725D0b454B76c199b9",
        chainId: 56,
        decimals: 18,
        logoURI: "https://exchange.pancakeswap.finance/images/coins/0x3c037c4c2296f280bb318d725d0b454b76c199b9.png",
    },
    SPART: {
        name: "SPARTAN PROTOCOL TOKEN",
        symbol: "SPART",
        address: "0xE4Ae305ebE1AbE663f261Bc00534067C80ad677C",
        chainId: 56,
        decimals: 18,
        logoURI: "https://exchange.pancakeswap.finance/images/coins/0xe4ae305ebe1abe663f261bc00534067c80ad677c.png",
    },
    TWT: {
        name: "Trust Wallet",
        symbol: "TWT",
        address: "0x4B0F1812e5Df2A09796481Ff14017e6005508003",
        chainId: 56,
        decimals: 18,
        logoURI: "https://exchange.pancakeswap.finance/images/coins/0x4b0f1812e5df2a09796481ff14017e6005508003.png",
    },
    XVS: {
        name: "Venus",
        symbol: "XVS",
        address: "0xcF6BB5389c92Bdda8a3747Ddb454cB7a64626C63",
        chainId: 56,
        decimals: 18,
        logoURI: "https://exchange.pancakeswap.finance/images/coins/0xcf6bb5389c92bdda8a3747ddb454cb7a64626c63.png",
    },
    Beer: {
        name: "Beer Garden",
        symbol: "Beer",
        address: "0xbB8DB5e17BBe9c90Da8E3445E335b82d7cc53575",
        chainId: 56,
        decimals: 18,
        logoURI: "https://exchange.pancakeswap.finance/images/coins/0xbb8db5e17bbe9c90da8e3445e335b82d7cc53575.png",
    },
    ALPHA: {
        name: "AlphaToken",
        symbol: "ALPHA",
        address: "0xa1faa113cbE53436Df28FF0aEe54275c13B40975",
        chainId: 56,
        decimals: 18,
        logoURI: "https://exchange.pancakeswap.finance/images/coins/0xa1faa113cbe53436df28ff0aee54275c13b40975.png",
    },
    BIFI: {
        name: "Beefy.finance",
        symbol: "BIFI",
        address: "0xCa3F508B8e4Dd382eE878A314789373D80A5190A",
        chainId: 56,
        decimals: 18,
        logoURI: "https://exchange.pancakeswap.finance/images/coins/0xCa3F508B8e4Dd382eE878A314789373D80A5190A.png",
    },
    YFI: {
        name: "yearn.finance",
        symbol: "YFI",
        address: "0x88f1A5ae2A3BF98AEAF342D26B30a79438c9142e",
        chainId: 56,
        decimals: 18,
        logoURI: "https://exchange.pancakeswap.finance/images/coins/0x88f1a5ae2a3bf98aeaf342d26b30a79438c9142e.png",
    },
    UNI: {
        name: "Uniswap",
        symbol: "UNI",
        address: "0xBf5140A22578168FD562DCcF235E5D43A02ce9B1",
        chainId: 56,
        decimals: 18,
        logoURI: "https://exchange.pancakeswap.finance/images/coins/0xbf5140a22578168fd562dccf235e5d43a02ce9b1.png",
    },
    FRIES: {
        name: "fry.world",
        symbol: "FRIES",
        address: "0x393B312C01048b3ed2720bF1B090084C09e408A1",
        chainId: 56,
        decimals: 18,
        logoURI: "https://exchange.pancakeswap.finance/images/coins/0x393B312C01048b3ed2720bF1B090084C09e408A1.png",
    },
    STAX: {
        name: "StableXSwap",
        symbol: "STAX",
        address: "0x0Da6Ed8B13214Ff28e9Ca979Dd37439e8a88F6c4",
        chainId: 56,
        decimals: 18,
        logoURI: "https://exchange.pancakeswap.finance/images/coins/0x0da6ed8b13214ff28e9ca979dd37439e8a88f6c4.png",
    },
    FIL: {
        name: "Filecoin",
        symbol: "FIL",
        address: "0x0D8Ce2A99Bb6e3B7Db580eD848240e4a0F9aE153",
        chainId: 56,
        decimals: 18,
        logoURI: "https://exchange.pancakeswap.finance/images/coins/0x0d8ce2a99bb6e3b7db580ed848240e4a0f9ae153.png",
    },
    KAVA: {
        name: "KAVA",
        symbol: "KAVA",
        address: "0x5F88AB06e8dfe89DF127B2430Bba4Af600866035",
        chainId: 56,
        decimals: 6,
        logoURI: "https://exchange.pancakeswap.finance/images/coins/0x5F88AB06e8dfe89DF127B2430Bba4Af600866035.png",
    },
    USDX: {
        name: "USDX",
        symbol: "USDX",
        address: "0x1203355742e76875154C0D13eB81DCD7711dC7d9",
        chainId: 56,
        decimals: 6,
        logoURI: "https://exchange.pancakeswap.finance/images/coins/0x1203355742e76875154c0d13eb81dcd7711dc7d9.png",
    },
    INJ: {
        name: "Injective Protocol",
        symbol: "INJ",
        address: "0xa2B726B1145A4773F68593CF171187d8EBe4d495",
        chainId: 56,
        decimals: 18,
        logoURI: "https://exchange.pancakeswap.finance/images/coins/0xa2B726B1145A4773F68593CF171187d8EBe4d495.png",
    },
    SXP: {
        name: "Swipe",
        symbol: "SXP",
        address: "0x47BEAd2563dCBf3bF2c9407fEa4dC236fAbA485A",
        chainId: 56,
        decimals: 18,
        logoURI: "https://exchange.pancakeswap.finance/images/coins/0x47bead2563dcbf3bf2c9407fea4dc236faba485a.png",
    },
    USDC: {
        name: "Binance-Peg USD Coin",
        symbol: "USDC",
        address: "0x8AC76a51cc950d9822D68b83fE1Ad97B32Cd580d",
        chainId: 56,
        decimals: 18,
        logoURI: "https://exchange.pancakeswap.finance/images/coins/0x8ac76a51cc950d9822d68b83fe1ad97b32cd580d.png",
    },
    CTK: {
        name: "CertiK Token",
        symbol: "CTK",
        address: "0xA8c2B8eec3d368C0253ad3dae65a5F2BBB89c929",
        chainId: 56,
        decimals: 6,
        logoURI: "https://exchange.pancakeswap.finance/images/coins/0xa8c2b8eec3d368c0253ad3dae65a5f2bbb89c929.png",
    },
    NAR: {
        name: "NAR Token",
        symbol: "NAR",
        address: "0xA1303E6199b319a891b79685F0537D289af1FC83",
        chainId: 56,
        decimals: 18,
        logoURI: "https://exchange.pancakeswap.finance/images/coins/0xa1303e6199b319a891b79685f0537d289af1fc83.png",
    },
    NYA: {
        name: "Nyanswop Token",
        symbol: "NYA",
        address: "0xbFa0841F7a90c4CE6643f651756EE340991F99D5",
        chainId: 56,
        decimals: 18,
        logoURI: "https://exchange.pancakeswap.finance/images/coins/0xbfa0841f7a90c4ce6643f651756ee340991f99d5.png",
    },
    DANGO: {
        name: "DANGO",
        symbol: "DANGO",
        address: "0x0957C57C9EB7744850dCC95db5A06eD4a246236E",
        chainId: 56,
        decimals: 6,
        logoURI: "https://exchange.pancakeswap.finance/images/coins/0x0957c57c9eb7744850dcc95db5a06ed4a246236e.png",
    },
    HARD: {
        name: "HARD",
        symbol: "HARD",
        address: "0xf79037F6f6bE66832DE4E7516be52826BC3cBcc4",
        chainId: 56,
        decimals: 6,
        logoURI: "https://exchange.pancakeswap.finance/images/coins/0xf79037f6f6be66832de4e7516be52826bc3cbcc4.png",
    },
    bROOBEE: {
        name: "ROOBEE",
        symbol: "bROOBEE",
        address: "0xE64F5Cb844946C1F102Bd25bBD87a5aB4aE89Fbe",
        chainId: 56,
        decimals: 18,
        logoURI: "https://exchange.pancakeswap.finance/images/coins/0xe64f5cb844946c1f102bd25bbd87a5ab4ae89fbe.png",
    },
    UNFI: {
        name: "Unifi Token",
        symbol: "UNFI",
        address: "0x728C5baC3C3e370E372Fc4671f9ef6916b814d8B",
        chainId: 56,
        decimals: 18,
        logoURI: "https://exchange.pancakeswap.finance/images/coins/0x728C5baC3C3e370E372Fc4671f9ef6916b814d8B.png",
    },
    BLK: {
        name: "BLINk",
        symbol: "BLK",
        address: "0x63870A18B6e42b01Ef1Ad8A2302ef50B7132054F",
        chainId: 56,
        decimals: 6,
        logoURI: "https://exchange.pancakeswap.finance/images/coins/0x63870A18B6e42b01Ef1Ad8A2302ef50B7132054F.png",
    },
    QUSD: {
        name: "QUSD Stablecoin",
        symbol: "QUSD",
        address: "0xb8C540d00dd0Bf76ea12E4B4B95eFC90804f924E",
        chainId: 56,
        decimals: 18,
        logoURI: "https://exchange.pancakeswap.finance/images/coins/0xb8C540d00dd0Bf76ea12E4B4B95eFC90804f924E.png",
    },
    KUN: {
        name: "Qian Governance Token",
        symbol: "KUN",
        address: "0x1A2fb0Af670D0234c2857FaD35b789F8Cb725584",
        chainId: 56,
        decimals: 18,
        logoURI: "https://exchange.pancakeswap.finance/images/coins/0x1A2fb0Af670D0234c2857FaD35b789F8Cb725584.png",
    },
    VAI: {
        name: "VAI Stablecoin",
        symbol: "VAI",
        address: "0x4BD17003473389A42DAF6a0a729f6Fdb328BbBd7",
        chainId: 56,
        decimals: 18,
        logoURI: "https://exchange.pancakeswap.finance/images/coins/0x4bd17003473389a42daf6a0a729f6fdb328bbbd7.png",
    },
    JUV: {
        name: "Juventus",
        symbol: "JUV",
        address: "0xC40C9A843E1c6D01b7578284a9028854f6683b1B",
        chainId: 56,
        decimals: 2,
        logoURI: "https://exchange.pancakeswap.finance/images/coins/0xc40c9a843e1c6d01b7578284a9028854f6683b1b.png",
    },
    PSG: {
        name: "Paris Saint-Germain",
        symbol: "PSG",
        address: "0xBc5609612b7C44BEf426De600B5fd1379DB2EcF1",
        chainId: 56,
        decimals: 2,
        logoURI: "https://exchange.pancakeswap.finance/images/coins/0xbc5609612b7c44bef426de600b5fd1379db2ecf1.png",
    },
    DITTO: {
        name: "Ditto",
        symbol: "DITTO",
        address: "0x233d91A0713155003fc4DcE0AFa871b508B3B715",
        chainId: 56,
        decimals: 9,
        logoURI: "https://exchange.pancakeswap.finance/images/coins/0x233d91A0713155003fc4DcE0AFa871b508B3B715.png",
    },
    MATH: {
        name: "Math",
        symbol: "MATH",
        address: "0xF218184Af829Cf2b0019F8E6F0b2423498a36983",
        chainId: 56,
        decimals: 18,
        logoURI: "https://exchange.pancakeswap.finance/images/coins/0xf218184af829cf2b0019f8e6f0b2423498a36983.png",
    },
    FUEL: {
        name: "Fuel",
        symbol: "FUEL",
        address: "0x2090c8295769791ab7A3CF1CC6e0AA19F35e441A",
        chainId: 56,
        decimals: 18,
        logoURI: "https://exchange.pancakeswap.finance/images/coins/0x2090c8295769791ab7A3CF1CC6e0AA19F35e441A.png",
    },
    NULS: {
        name: "Nuls",
        symbol: "NULS",
        address: "0x8CD6e29d3686d24d3C2018CEe54621eA0f89313B",
        chainId: 56,
        decimals: 8,
        logoURI: "https://exchange.pancakeswap.finance/images/coins/0x8cd6e29d3686d24d3c2018cee54621ea0f89313b.png",
    },
    NVT: {
        name: "NerveNetwork",
        symbol: "NVT",
        address: "0xf0E406c49C63AbF358030A299C0E00118C4C6BA5",
        chainId: 56,
        decimals: 8,
        logoURI: "https://exchange.pancakeswap.finance/images/coins/0xf0e406c49c63abf358030a299c0e00118c4c6ba5.png",
    },
    REEF: {
        name: "Reef",
        symbol: "REEF",
        address: "0xF21768cCBC73Ea5B6fd3C687208a7c2def2d966e",
        chainId: 56,
        decimals: 18,
        logoURI: "https://exchange.pancakeswap.finance/images/coins/0xf21768ccbc73ea5b6fd3c687208a7c2def2d966e.png",
    },
    OG: {
        name: "OG",
        symbol: "OG",
        address: "0xf05E45aD22150677a017Fbd94b84fBB63dc9b44c",
        chainId: 56,
        decimals: 2,
        logoURI: "https://exchange.pancakeswap.finance/images/coins/0xf05e45ad22150677a017fbd94b84fbb63dc9b44c.png",
    },
    ATM: {
        name: "Atletico de Madrid",
        symbol: "ATM",
        address: "0x25E9d05365c867E59C1904E7463Af9F312296f9E",
        chainId: 56,
        decimals: 2,
        logoURI: "https://exchange.pancakeswap.finance/images/coins/0x25e9d05365c867e59c1904e7463af9f312296f9e.png",
    },
    ASR: {
        name: "AS Roma",
        symbol: "ASR",
        address: "0x80D5f92C2c8C682070C95495313dDB680B267320",
        chainId: 56,
        decimals: 2,
        logoURI: "https://exchange.pancakeswap.finance/images/coins/0x80d5f92c2c8c682070c95495313ddb680b267320.png",
    },
    bALBT: {
        name: "AllianceBlock",
        symbol: "bALBT",
        address: "0x72fAa679E1008Ad8382959FF48E392042A8b06f7",
        chainId: 56,
        decimals: 18,
        logoURI: "https://exchange.pancakeswap.finance/images/coins/0x72faa679e1008ad8382959ff48e392042a8b06f7.png",
    },
    TEN: {
        name: "Tenet",
        symbol: "TEN",
        address: "0xdFF8cb622790b7F92686c722b02CaB55592f152C",
        chainId: 56,
        decimals: 18,
        logoURI: "https://exchange.pancakeswap.finance/images/coins/0xdff8cb622790b7f92686c722b02cab55592f152c.png",
    },
    Helmet: {
        name: "Helmet.insure",
        symbol: "Helmet",
        address: "0x948d2a81086A075b3130BAc19e4c6DEe1D2E3fE8",
        chainId: 56,
        decimals: 18,
        logoURI: "https://exchange.pancakeswap.finance/images/coins/0x948d2a81086a075b3130bac19e4c6dee1d2e3fe8.png",
    },
    BSCX: {
        name: "BSCEX",
        symbol: "BSCX",
        address: "0x5Ac52EE5b2a633895292Ff6d8A89bB9190451587",
        chainId: 56,
        decimals: 18,
        logoURI: "https://exchange.pancakeswap.finance/images/coins/0x5ac52ee5b2a633895292ff6d8a89bb9190451587.png",
    },
    BTCST: {
        name: "Standard BTC Hashrate Token",
        symbol: "BTCST",
        address: "0x78650B139471520656b9E7aA7A5e9276814a38e9",
        chainId: 56,
        decimals: 17,
        logoURI: "https://exchange.pancakeswap.finance/images/coins/0x78650b139471520656b9e7aa7a5e9276814a38e9.png",
    },
    FRONT: {
        name: "Frontier Token",
        symbol: "FRONT",
        address: "0x928e55daB735aa8260AF3cEDadA18B5f70C72f1b",
        chainId: 56,
        decimals: 18,
        logoURI: "https://exchange.pancakeswap.finance/images/coins/0x928e55daB735aa8260AF3cEDadA18B5f70C72f1b.png",
    },
    WSOTE: {
        name: "Soteria",
        symbol: "WSOTE",
        address: "0x541E619858737031A1244A5d0Cd47E5ef480342c",
        chainId: 56,
        decimals: 18,
        logoURI: "https://exchange.pancakeswap.finance/images/coins/0x541e619858737031a1244a5d0cd47e5ef480342c.png",
    },
    MTSLA: {
        name: "Mirror TSLA Token",
        symbol: "MTSLA",
        address: "0xF215A127A196e3988C09d052e16BcFD365Cd7AA3",
        chainId: 56,
        decimals: 18,
        logoURI: "https://exchange.pancakeswap.finance/images/coins/0xF215A127A196e3988C09d052e16BcFD365Cd7AA3.png",
    },
    MAMZN: {
        name: "Mirror AMZN Token",
        symbol: "MAMZN",
        address: "0x3947B992DC0147D2D89dF0392213781b04B25075",
        chainId: 56,
        decimals: 18,
        logoURI: "https://exchange.pancakeswap.finance/images/coins/0x3947B992DC0147D2D89dF0392213781b04B25075.png",
    },
    MNFLX: {
        name: "Mirror NFLX Token",
        symbol: "MNFLX",
        address: "0xa04F060077D90Fe2647B61e4dA4aD1F97d6649dc",
        chainId: 56,
        decimals: 18,
        logoURI: "https://exchange.pancakeswap.finance/images/coins/0xa04F060077D90Fe2647B61e4dA4aD1F97d6649dc.png",
    },
    MGOOGL: {
        name: "Mirror GOOGL Token",
        symbol: "MGOOGL",
        address: "0x62D71B23bF15218C7d2D7E48DBbD9e9c650B173f",
        chainId: 56,
        decimals: 18,
        logoURI: "https://exchange.pancakeswap.finance/images/coins/0x62D71B23bF15218C7d2D7E48DBbD9e9c650B173f.png",
    },
    UST: {
        name: "UST Token",
        symbol: "UST",
        address: "0x23396cF899Ca06c4472205fC903bDB4de249D6fC",
        chainId: 56,
        decimals: 18,
        logoURI: "https://exchange.pancakeswap.finance/images/coins/0x23396cF899Ca06c4472205fC903bDB4de249D6fC.png",
    },
    BFI: {
        name: "b.earnfi",
        symbol: "BFI",
        address: "0x81859801b01764D4f0Fa5E64729f5a6C3b91435b",
        chainId: 56,
        decimals: 18,
        logoURI: "https://exchange.pancakeswap.finance/images/coins/0x81859801b01764D4f0Fa5E64729f5a6C3b91435b.png",
    },
    BDO: {
        name: "bDollar",
        symbol: "BDO",
        address: "0x190b589cf9Fb8DDEabBFeae36a813FFb2A702454",
        chainId: 56,
        decimals: 18,
        logoURI: "https://exchange.pancakeswap.finance/images/coins/0x190b589cf9Fb8DDEabBFeae36a813FFb2A702454.png",
    },
    sBDO: {
        name: "bDollar Share",
        symbol: "sBDO",
        address: "0x0d9319565be7f53CeFE84Ad201Be3f40feAE2740",
        chainId: 56,
        decimals: 18,
        logoURI: "https://exchange.pancakeswap.finance/images/coins/0x0d9319565be7f53CeFE84Ad201Be3f40feAE2740.png",
    },
    EGLD: {
        name: "Elrond",
        symbol: "EGLD",
        address: "0xbF7c81FFF98BbE61B40Ed186e4AfD6DDd01337fe",
        chainId: 56,
        decimals: 18,
        logoURI: "https://exchange.pancakeswap.finance/images/coins/0xbf7c81fff98bbe61b40ed186e4afd6ddd01337fe.png",
    },
    AUTO: {
        name: "AUTOv2",
        symbol: "AUTO",
        address: "0xa184088a740c695E156F91f5cC086a06bb78b827",
        chainId: 56,
        decimals: 18,
        logoURI: "https://exchange.pancakeswap.finance/images/coins/0xa184088a740c695e156f91f5cc086a06bb78b827.png",
    },
    HGET: {
        name: "Hedget",
        symbol: "HGET",
        address: "0xC7d8D35EBA58a0935ff2D5a33Df105DD9f071731",
        chainId: 56,
        decimals: 6,
        logoURI: "https://exchange.pancakeswap.finance/images/coins/0xC7d8D35EBA58a0935ff2D5a33Df105DD9f071731.png",
    },
    LIT: {
        name: "Litentry",
        symbol: "LIT",
        address: "0xb59490aB09A0f526Cc7305822aC65f2Ab12f9723",
        chainId: 56,
        decimals: 18,
        logoURI: "https://exchange.pancakeswap.finance/images/coins/0xb59490ab09a0f526cc7305822ac65f2ab12f9723.png",
    },
    LINA: {
        name: "Linear Finance",
        symbol: "LINA",
        address: "0x762539b45A1dCcE3D36d080F74d1AED37844b878",
        chainId: 56,
        decimals: 18,
        logoURI: "https://exchange.pancakeswap.finance/images/coins/0x762539b45a1dcce3d36d080f74d1aed37844b878.png",
    },
    BETH: {
        name: "Beacon ETH",
        symbol: "BETH",
        address: "0x250632378E573c6Be1AC2f97Fcdf00515d0Aa91B",
        chainId: 56,
        decimals: 18,
        logoURI: "https://exchange.pancakeswap.finance/images/coins/0x250632378e573c6be1ac2f97fcdf00515d0aa91b.png",
    },
    lUSD: {
        name: "lUSD",
        symbol: "lUSD",
        address: "0x23e8a70534308a4AAF76fb8C32ec13d17a3BD89e",
        chainId: 56,
        decimals: 18,
        logoURI: "https://exchange.pancakeswap.finance/images/coins/0x23e8a70534308a4AAF76fb8C32ec13d17a3BD89e.png",
    },
    SFP: {
        name: "SafePal Token",
        symbol: "SFP",
        address: "0xD41FDb03Ba84762dD66a0af1a6C8540FF1ba5dfb",
        chainId: 56,
        decimals: 18,
        logoURI: "https://exchange.pancakeswap.finance/images/coins/0xd41fdb03ba84762dd66a0af1a6c8540ff1ba5dfb.png",
    },
    COMP: {
        name: "Compound Finance",
        symbol: "COMP",
        address: "0x52CE071Bd9b1C4B00A0b92D298c512478CaD67e8",
        chainId: 56,
        decimals: 18,
        logoURI: "https://exchange.pancakeswap.finance/images/coins/0x52ce071bd9b1c4b00a0b92d298c512478cad67e8.png",
    },
    SWGB: {
        name: "Swirge Pay",
        symbol: "SWGB",
        address: "0xE40255C5d7fa7ceEc5120408C78C787CECB4cfdb",
        chainId: 56,
        decimals: 18,
        logoURI: "https://exchange.pancakeswap.finance/images/coins/0xe40255c5d7fa7ceec5120408c78c787cecb4cfdb.png",
    },
    renBTC: {
        name: "renBTC",
        symbol: "renBTC",
        address: "0xfCe146bF3146100cfe5dB4129cf6C82b0eF4Ad8c",
        chainId: 56,
        decimals: 8,
        logoURI: "https://exchange.pancakeswap.finance/images/coins/0xfCe146bF3146100cfe5dB4129cf6C82b0eF4Ad8c.png",
    },
    renDOGE: {
        name: "renDOGE",
        symbol: "renDOGE",
        address: "0xc3fEd6eB39178A541D274e6Fc748d48f0Ca01CC3",
        chainId: 56,
        decimals: 8,
        logoURI: "https://exchange.pancakeswap.finance/images/coins/0xc3fed6eb39178a541d274e6fc748d48f0ca01cc3.png",
    },
    anyMTLX: {
        name: "anyMTLX",
        symbol: "anyMTLX",
        address: "0x5921DEE8556c4593EeFCFad3CA5e2f618606483b",
        chainId: 56,
        decimals: 18,
        logoURI: "https://exchange.pancakeswap.finance/images/coins/0x5921dee8556c4593eefcfad3ca5e2f618606483b.png",
    },
    ZEE: {
        name: "ZeroSwapToken",
        symbol: "ZEE",
        address: "0x44754455564474A89358B2C2265883DF993b12F0",
        chainId: 56,
        decimals: 18,
        logoURI: "https://exchange.pancakeswap.finance/images/coins/0x44754455564474a89358b2c2265883df993b12f0.png",
    },
    BRY: {
        name: "Berry",
        symbol: "BRY",
        address: "0xf859Bf77cBe8699013d6Dbc7C2b926Aaf307F830",
        chainId: 56,
        decimals: 18,
        logoURI: "https://exchange.pancakeswap.finance/images/coins/0xf859Bf77cBe8699013d6Dbc7C2b926Aaf307F830.png",
    },
    SWINGBY: {
        name: "Swingby",
        symbol: "SWINGBY",
        address: "0x71DE20e0C4616E7fcBfDD3f875d568492cBE4739",
        chainId: 56,
        decimals: 18,
        logoURI: "https://exchange.pancakeswap.finance/images/coins/0x71DE20e0C4616E7fcBfDD3f875d568492cBE4739.png",
    },
    DODO: {
        name: "Dodo",
        symbol: "DODO",
        address: "0x67ee3Cb086F8a16f34beE3ca72FAD36F7Db929e2",
        chainId: 56,
        decimals: 18,
        logoURI: "https://exchange.pancakeswap.finance/images/coins/0x67ee3cb086f8a16f34bee3ca72fad36f7db929e2.png",
    },
    SUSHI: {
        name: "Sushi",
        symbol: "SUSHI",
        address: "0x947950BcC74888a40Ffa2593C5798F11Fc9124C4",
        chainId: 56,
        decimals: 18,
        logoURI: "https://exchange.pancakeswap.finance/images/coins/0x947950bcc74888a40ffa2593c5798f11fc9124c4.png",
    },
    BOPEN: {
        name: "OPEN Governance Token",
        symbol: "BOPEN",
        address: "0xF35262a9d427F96d2437379eF090db986eaE5d42",
        chainId: 56,
        decimals: 18,
        logoURI: "https://exchange.pancakeswap.finance/images/coins/0xF35262a9d427F96d2437379eF090db986eaE5d42.png",
    },
    BOR: {
        name: "BoringDAO",
        symbol: "BOR",
        address: "0x92D7756c60dcfD4c689290E8A9F4d263b3b32241",
        chainId: 56,
        decimals: 18,
        logoURI: "https://exchange.pancakeswap.finance/images/coins/0x92d7756c60dcfd4c689290e8a9f4d263b3b32241.png",
    },
    renZEC: {
        name: "renZEC",
        symbol: "renZEC",
        address: "0x695FD30aF473F2960e81Dc9bA7cB67679d35EDb7",
        chainId: 56,
        decimals: 8,
        logoURI: "https://exchange.pancakeswap.finance/images/coins/0x695FD30aF473F2960e81Dc9bA7cB67679d35EDb7.png",
    },
    BMXX: {
        name: "Multiplier",
        symbol: "BMXX",
        address: "0x4131b87F74415190425ccD873048C708F8005823",
        chainId: 56,
        decimals: 18,
        logoURI: "https://exchange.pancakeswap.finance/images/coins/0x4131b87f74415190425ccd873048c708f8005823.png",
    },
    IOTX: {
        name: "IoTeX",
        symbol: "IOTX",
        address: "0x9678E42ceBEb63F23197D726B29b1CB20d0064E5",
        chainId: 56,
        decimals: 18,
        logoURI: "https://exchange.pancakeswap.finance/images/coins/0x9678e42cebeb63f23197d726b29b1cb20d0064e5.png",
    },
    XMARK: {
        name: "xMARK",
        symbol: "XMARK",
        address: "0x26A5dFab467d4f58fB266648CAe769503CEC9580",
        chainId: 56,
        decimals: 9,
        logoURI: "https://exchange.pancakeswap.finance/images/coins/0x26a5dfab467d4f58fb266648cae769503cec9580.png",
    },
    TPT: {
        name: "TokenPocket",
        symbol: "TPT",
        address: "0xECa41281c24451168a37211F0bc2b8645AF45092",
        chainId: 56,
        decimals: 4,
        logoURI: "https://exchange.pancakeswap.finance/images/coins/0xeca41281c24451168a37211f0bc2b8645af45092.png",
    },
    WATCH: {
        name: "Yieldwatch",
        symbol: "WATCH",
        address: "0x7A9f28EB62C791422Aa23CeAE1dA9C847cBeC9b0",
        chainId: 56,
        decimals: 18,
        logoURI: "https://exchange.pancakeswap.finance/images/coins/0x7a9f28eb62c791422aa23ceae1da9c847cbec9b0.png",
    },
    BEL: {
        name: "Bella Protocol",
        symbol: "BEL",
        address: "0x8443f091997f06a61670B735ED92734F5628692F",
        chainId: 56,
        decimals: 18,
        logoURI: "https://exchange.pancakeswap.finance/images/coins/0x8443f091997f06a61670b735ed92734f5628692f.png",
    },
    DEXE: {
        name: "DeXe",
        symbol: "DEXE",
        address: "0x039cB485212f996A9DBb85A9a75d898F94d38dA6",
        chainId: 56,
        decimals: 18,
        logoURI: "https://exchange.pancakeswap.finance/images/coins/0x039cb485212f996a9dbb85a9a75d898f94d38da6.png",
    },
    RAMP: {
        name: "Ramp DEFI",
        symbol: "RAMP",
        address: "0x8519EA49c997f50cefFa444d240fB655e89248Aa",
        chainId: 56,
        decimals: 18,
        logoURI: "https://exchange.pancakeswap.finance/images/coins/0x8519ea49c997f50ceffa444d240fb655e89248aa.png",
    },
    BELT: {
        name: "Belt",
        symbol: "BELT",
        address: "0xE0e514c71282b6f4e823703a39374Cf58dc3eA4f",
        chainId: 56,
        decimals: 18,
        logoURI: "https://exchange.pancakeswap.finance/images/coins/0xE0e514c71282b6f4e823703a39374Cf58dc3eA4f.png",
    },
    BAT: {
        name: "Basic Attention Token",
        symbol: "BAT",
        address: "0x101d82428437127bF1608F699CD651e6Abf9766E",
        chainId: 56,
        decimals: 18,
        logoURI: "https://exchange.pancakeswap.finance/images/coins/0x101d82428437127bf1608f699cd651e6abf9766e.png",
    },
    BUX: {
        name: "BUX",
        symbol: "BUX",
        address: "0x211FfbE424b90e25a15531ca322adF1559779E45",
        chainId: 56,
        decimals: 18,
        logoURI: "https://exchange.pancakeswap.finance/images/coins/0x211ffbe424b90e25a15531ca322adf1559779e45.png",
    },
    FOR: {
        name: "ForTube",
        symbol: "FOR",
        address: "0x658A109C5900BC6d2357c87549B651670E5b0539",
        chainId: 56,
        decimals: 18,
        logoURI: "https://exchange.pancakeswap.finance/images/coins/0x658A109C5900BC6d2357c87549B651670E5b0539.png",
    },
    ALICE: {
        name: "My Neigbor Alice",
        symbol: "ALICE",
        address: "0xAC51066d7bEC65Dc4589368da368b212745d63E8",
        chainId: 56,
        decimals: 6,
        logoURI: "https://exchange.pancakeswap.finance/images/coins/0xac51066d7bec65dc4589368da368b212745d63e8.png",
    },
    BUNNY: {
        name: "Pancake Bunny",
        symbol: "BUNNY",
        address: "0xC9849E6fdB743d08fAeE3E34dd2D1bc69EA11a51",
        chainId: 56,
        decimals: 18,
        logoURI: "https://exchange.pancakeswap.finance/images/coins/0xc9849e6fdb743d08faee3e34dd2d1bc69ea11a51.png",
    },
    DEGO: {
        name: "Dego.Finance",
        symbol: "DEGO",
        address: "0x3FdA9383A84C05eC8f7630Fe10AdF1fAC13241CC",
        chainId: 56,
        decimals: 18,
        logoURI: "https://exchange.pancakeswap.finance/images/coins/0x3fda9383a84c05ec8f7630fe10adf1fac13241cc.png",
    },
    LTO: {
        name: "LTO Network",
        symbol: "LTO",
        address: "0x857B222Fc79e1cBBf8Ca5f78CB133d1b7CF34BBd",
        chainId: 56,
        decimals: 18,
        logoURI: "https://exchange.pancakeswap.finance/images/coins/0x857b222fc79e1cbbf8ca5f78cb133d1b7cf34bbd.png",
    },
    COS: {
        name: "Contentos",
        symbol: "COS",
        address: "0x96Dd399F9c3AFda1F194182F71600F1B65946501",
        chainId: 56,
        decimals: 18,
        logoURI: "https://exchange.pancakeswap.finance/images/coins/0x96dd399f9c3afda1f194182f71600f1b65946501.png",
    },
    TXL: {
        name: "Tixl",
        symbol: "TXL",
        address: "0x1FFD0b47127fdd4097E54521C9E2c7f0D66AafC5",
        chainId: 56,
        decimals: 18,
        logoURI: "https://exchange.pancakeswap.finance/images/coins/0x1ffd0b47127fdd4097e54521c9e2c7f0d66aafc5.png",
    },
    ALPACA: {
        name: "Alpaca",
        symbol: "ALPACA",
        address: "0x8F0528cE5eF7B51152A59745bEfDD91D97091d2F",
        chainId: 56,
        decimals: 18,
        logoURI: "https://exchange.pancakeswap.finance/images/coins/0x8f0528ce5ef7b51152a59745befdd91d97091d2f.png",
    },
    DUSK: {
        name: "Dusk",
        symbol: "DUSK",
        address: "0xB2BD0749DBE21f623d9BABa856D3B0f0e1BFEc9C",
        chainId: 56,
        decimals: 18,
        logoURI: "https://exchange.pancakeswap.finance/images/coins/0xb2bd0749dbe21f623d9baba856d3b0f0e1bfec9c.png",
    },
    bDIGG: {
        name: "bDIGG",
        symbol: "bDIGG",
        address: "0x5986D5c77c65e5801a5cAa4fAE80089f870A71dA",
        chainId: 56,
        decimals: 18,
        logoURI: "https://exchange.pancakeswap.finance/images/coins/0x5986d5c77c65e5801a5caa4fae80089f870a71da.png",
    },
    bBADGER: {
        name: "bBADGER",
        symbol: "bBADGER",
        address: "0x1F7216fdB338247512Ec99715587bb97BBf96eae",
        chainId: 56,
        decimals: 18,
        logoURI: "https://exchange.pancakeswap.finance/images/coins/0x1f7216fdb338247512ec99715587bb97bbf96eae.png",
    },
    TRADE: {
        name: "Unitrade",
        symbol: "TRADE",
        address: "0x7af173F350D916358AF3e218Bdf2178494Beb748",
        chainId: 56,
        decimals: 18,
        logoURI: "https://exchange.pancakeswap.finance/images/coins/0x7af173f350d916358af3e218bdf2178494beb748.png",
    },
    PNT: {
        name: "PNT",
        symbol: "PNT",
        address: "0xdaacB0Ab6Fb34d24E8a67BfA14BF4D95D4C7aF92",
        chainId: 56,
        decimals: 18,
        logoURI: "https://exchange.pancakeswap.finance/images/coins/0x7a1da9f49224ef98389b071b8a3294d1cc5e3e6a.png",
    },
    pBTC: {
        name: "pBTC",
        symbol: "pBTC",
        address: "0xeD28A457A5A76596ac48d87C0f577020F6Ea1c4C",
        chainId: 56,
        decimals: 18,
        logoURI: "https://exchange.pancakeswap.finance/images/coins/0xed28a457a5a76596ac48d87c0f577020f6ea1c4c.png",
    },
    MIR: {
        name: "Mirror Finance",
        symbol: "MIR",
        address: "0x5B6DcF557E2aBE2323c48445E8CC948910d8c2c9",
        chainId: 56,
        decimals: 18,
        logoURI: "https://exchange.pancakeswap.finance/images/coins/0x5b6dcf557e2abe2323c48445e8cc948910d8c2c9.png",
    },
    pCWS: {
        name: "PolyCrowns",
        symbol: "pCWS",
        address: "0xbcf39F0EDDa668C58371E519AF37CA705f2bFcbd",
        chainId: 56,
        decimals: 18,
        logoURI: "https://exchange.pancakeswap.finance/images/coins/0xbcf39f0edda668c58371e519af37ca705f2bfcbd.png",
    },
    ZIL: {
        name: "Zilliqa",
        symbol: "ZIL",
        address: "0xb86AbCb37C3A4B64f74f59301AFF131a1BEcC787",
        chainId: 56,
        decimals: 12,
        logoURI: "https://exchange.pancakeswap.finance/images/coins/0xb86abcb37c3a4b64f74f59301aff131a1becc787.png",
    },
    LIEN: {
        name: "Lien",
        symbol: "LIEN",
        address: "0x5d684ADaf3FcFe9CFb5ceDe3abf02F0Cdd1012E3",
        chainId: 56,
        decimals: 8,
        logoURI: "https://exchange.pancakeswap.finance/images/coins/0x5d684adaf3fcfe9cfb5cede3abf02f0cdd1012e3.png",
    },
    SWTH: {
        name: "Switcheo",
        symbol: "SWTH",
        address: "0x250b211EE44459dAd5Cd3bCa803dD6a7EcB5d46C",
        chainId: 56,
        decimals: 8,
        logoURI: "https://exchange.pancakeswap.finance/images/coins/0x250b211EE44459dAd5Cd3bCa803dD6a7EcB5d46C.png",
    },
    EPS: {
        name: "Ellipsis",
        symbol: "EPS",
        address: "0xA7f552078dcC247C2684336020c03648500C6d9F",
        chainId: 56,
        decimals: 18,
        logoURI: "https://exchange.pancakeswap.finance/images/coins/0xa7f552078dcc247c2684336020c03648500c6d9f.png",
    },
    DFT: {
        name: "DFuture",
        symbol: "DFT",
        address: "0x42712dF5009c20fee340B245b510c0395896cF6e",
        chainId: 56,
        decimals: 18,
        logoURI: "https://exchange.pancakeswap.finance/images/coins/0x42712dF5009c20fee340B245b510c0395896cF6e.png",
    },
    GUM: {
        name: "Gourmet Galaxy",
        symbol: "GUM",
        address: "0xc53708664b99DF348dd27C3Ac0759d2DA9c40462",
        chainId: 56,
        decimals: 18,
        logoURI: "https://exchange.pancakeswap.finance/images/coins/0xc53708664b99DF348dd27C3Ac0759d2DA9c40462.png",
    },
    "ONE-Harmony One": {
        name: "Harmony One",
        symbol: "ONE",
        address: "0x03fF0ff224f904be3118461335064bB48Df47938",
        chainId: 56,
        decimals: 18,
        logoURI: "https://exchange.pancakeswap.finance/images/coins/0x03ff0ff224f904be3118461335064bb48df47938.png",
    },
    NRV: {
        name: "Nerve Finance",
        symbol: "NRV",
        address: "0x42F6f551ae042cBe50C739158b4f0CAC0Edb9096",
        chainId: 56,
        decimals: 18,
        logoURI: "https://exchange.pancakeswap.finance/images/coins/0x42f6f551ae042cbe50c739158b4f0cac0edb9096.png",
    },
    EASY: {
        name: "Easyfi Network",
        symbol: "EASY",
        address: "0x7C17c8bED8d14bAccE824D020f994F4880D6Ab3B",
        chainId: 56,
        decimals: 18,
        logoURI: "https://exchange.pancakeswap.finance/images/coins/0x7c17c8bed8d14bacce824d020f994f4880d6ab3b.png",
    },
    SAFEMOON: {
        name: "SafeMoon",
        symbol: "SAFEMOON",
        address: "0x8076C74C5e3F5852037F31Ff0093Eeb8c8ADd8D3",
        chainId: 56,
        decimals: 9,
        logoURI: "https://exchange.pancakeswap.finance/images/coins/0x8076c74c5e3f5852037f31ff0093eeb8c8add8d3.png",
    },
    tBTC: {
        name: "Tau Bitcoin",
        symbol: "tBTC",
        address: "0x2cD1075682b0FCCaADd0Ca629e138E64015Ba11c",
        chainId: 56,
        decimals: 9,
        logoURI: "https://exchange.pancakeswap.finance/images/coins/0x2cD1075682b0FCCaADd0Ca629e138E64015Ba11c.png",
    },
    HOO: {
        name: "Hoo",
        symbol: "HOO",
        address: "0xE1d1F66215998786110Ba0102ef558b22224C016",
        chainId: 56,
        decimals: 8,
        logoURI: "https://exchange.pancakeswap.finance/images/coins/0xe1d1f66215998786110ba0102ef558b22224c016.png",
    },
    ODDZ: {
        name: "Oddz",
        symbol: "ODDZ",
        address: "0xCD40F2670CF58720b694968698A5514e924F742d",
        chainId: 56,
        decimals: 18,
        logoURI: "https://exchange.pancakeswap.finance/images/coins/0xcd40f2670cf58720b694968698a5514e924f742d.png",
    },
    APYS: {
        name: "APYSwap",
        symbol: "APYS",
        address: "0x37dfACfaeDA801437Ff648A1559d73f4C40aAcb7",
        chainId: 56,
        decimals: 18,
        logoURI: "https://exchange.pancakeswap.finance/images/coins/0x37dfACfaeDA801437Ff648A1559d73f4C40aAcb7.png",
    },
    BONDLY: {
        name: "Bondly",
        symbol: "BONDLY",
        address: "0x96058f8C3e16576D9BD68766f3836d9A33158f89",
        chainId: 56,
        decimals: 18,
        logoURI: "https://exchange.pancakeswap.finance/images/coins/0x96058f8c3e16576d9bd68766f3836d9a33158f89.png",
    },
    TKO: {
        name: "TokoCrypto",
        symbol: "TKO",
        address: "0x9f589e3eabe42ebC94A44727b3f3531C0c877809",
        chainId: 56,
        decimals: 18,
        logoURI: "https://exchange.pancakeswap.finance/images/coins/0x9f589e3eabe42ebc94a44727b3f3531c0c877809.png",
    },
    ITAM: {
        name: "Itam",
        symbol: "ITAM",
        address: "0x04C747b40Be4D535fC83D09939fb0f626F32800B",
        chainId: 56,
        decimals: 18,
        logoURI: "https://exchange.pancakeswap.finance/images/coins/0x04c747b40be4d535fc83d09939fb0f626f32800b.png",
    },
    ARPA: {
        name: "ARPA",
        symbol: "ARPA",
        address: "0x6F769E65c14Ebd1f68817F5f1DcDb61Cfa2D6f7e",
        chainId: 56,
        decimals: 18,
        logoURI: "https://exchange.pancakeswap.finance/images/coins/0x6f769e65c14ebd1f68817f5f1dcdb61cfa2d6f7e.png",
    },
    PERL: {
        name: "Perlin X",
        symbol: "PERL",
        address: "0x0F9E4D49f25de22c2202aF916B681FBB3790497B",
        chainId: 56,
        decimals: 18,
        logoURI: "https://exchange.pancakeswap.finance/images/coins/0x0f9e4d49f25de22c2202af916b681fbb3790497b.png",
    },
    JGN: {
        name: "Juggernaut Finance",
        symbol: "JGN",
        address: "0xC13B7a43223BB9Bf4B69BD68Ab20ca1B79d81C75",
        chainId: 56,
        decimals: 18,
        logoURI: "https://exchange.pancakeswap.finance/images/coins/0xc13b7a43223bb9bf4b69bd68ab20ca1b79d81c75.png",
    },
    TLM: {
        name: "Alien Worlds",
        symbol: "TLM",
        address: "0x2222227E22102Fe3322098e4CBfE18cFebD57c95",
        chainId: 56,
        decimals: 4,
        logoURI: "https://exchange.pancakeswap.finance/images/coins/0x2222227e22102fe3322098e4cbfe18cfebd57c95.png",
    },
    ALPA: {
        name: "AlpaToken",
        symbol: "ALPA",
        address: "0xc5E6689C9c8B02be7C49912Ef19e79cF24977f03",
        chainId: 56,
        decimals: 18,
        logoURI: "https://exchange.pancakeswap.finance/images/coins/0xc5e6689c9c8b02be7c49912ef19e79cf24977f03.png",
    },
    HZN: {
        name: "Horizon Protocol",
        symbol: "HZN",
        address: "0xC0eFf7749b125444953ef89682201Fb8c6A917CD",
        chainId: 56,
        decimals: 18,
        logoURI: "https://exchange.pancakeswap.finance/images/coins/0xC0eFf7749b125444953ef89682201Fb8c6A917CD.png",
    },
    MTRG: {
        name: "Wrapped MTRG on BSC by Meter.io",
        symbol: "MTRG",
        address: "0xBd2949F67DcdC549c6Ebe98696449Fa79D988A9F",
        chainId: 56,
        decimals: 18,
        logoURI: "",
    },
    QKC: {
        name: "QuarkChain Token",
        symbol: "QKC",
        address: "0xA1434F1FC3F437fa33F7a781E041961C0205B5Da",
        chainId: 56,
        decimals: 18,
        logoURI: "",
    },
    MX: {
        name: "MX Token",
        symbol: "MX",
        address: "0x9F882567A62a5560d147d64871776EeA72Df41D3",
        chainId: 56,
        decimals: 18,
        logoURI: "",
    },
    BCFX: {
        name: "BSC Conflux",
        symbol: "BCFX",
        address: "0x045c4324039dA91c52C55DF5D785385Aab073DcF",
        chainId: 56,
        decimals: 18,
        logoURI: "https://bscscan.com/token/images/conflux_32.png",
    },
    "AMPL-BSC-mp": {
        name: "Ample BSC (BRG Meter Passport)",
        symbol: "AMPL-BSC-mp",
        address: "0xDB021b1B247fe2F1fa57e0A87C748Cc1E321F07F",
        chainId: 56,
        decimals: 9,
        logoURI: "",
    },
    dBTC: {
        name: "Diamond-Peg BTC",
        symbol: "dBTC",
        address: "0x6b77F51d4C474EFB15b72B829e6a0806bbc33724",
        chainId: 56,
        decimals: 18,
        logoURI: "https://app.iron.finance/static/media/DBTC.2bb24d53.png",
    },
    dBNB: {
        name: "Diamond-Peg BNB",
        symbol: "dBNB",
        address: "0x4101fe75F547A65F6BB054A35F027c16562a45C3",
        chainId: 56,
        decimals: 18,
        logoURI: "https://app.iron.finance/static/media/DBNB.57de3f13.png",
    },
    dETH: {
        name: "Diamond-Peg ETH",
        symbol: "dETH",
        address: "0xf633DEb2452918FA5248070C1986BE7a3895F3fC",
        chainId: 56,
        decimals: 18,
        logoURI: "https://app.iron.finance/static/media/DETH.4802e6eb.png",
    },
    dADA: {
        name: "Diamond-Peg ADA",
        symbol: "dADA",
        address: "0x68169d96a20dFe968B0fe714578969118c08484A",
        chainId: 56,
        decimals: 18,
        logoURI: "https://app.iron.finance/static/media/DADA.d9b1a86c.png",
    },
    dDOT: {
        name: "Diamond-Peg DOT",
        symbol: "dDOT",
        address: "0x3E3434F57ADF4e07Dc2d75c6F109c20Ac96a1557",
        chainId: 56,
        decimals: 18,
        logoURI: "",
    },
};
